"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tflex: 1 1 auto;\n\tbackground: #fff;\n\tcolor: #999;\n\t", ";\n\n\tspan {\n\t\ttext-align: center;\n\t\tmargin-left: ", ";\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding-left: ", ";\n\t\tpadding-right: ", ";\n\t\tmin-height: ", ";\n\t}\n\n\t&:first-child span {\n\t\tmargin-left: 0;\n\t}\n\n\t&:before,\n\t&:after {\n\t\tcontent: ' ';\n\t\tdisplay: block;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tborder-top: 5rem solid transparent;\n\t\tborder-bottom: 5rem solid transparent;\n\t\tborder-left: ", " solid ", ";\n\t\tmargin-top: -5rem;\n\t\tleft: 100%;\n\t}\n\n\t&:before {\n\t\tmargin-left: 1px;\n\t\tz-index: 1;\n\t}\n\n\t&:after {\n\t\tborder-left-color: white;\n\t\tz-index: 2;\n\t}\n\n\t", ";\n\n\t", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\ttext-align: center;\n\tborder-radius: 4px;\n\tbackground: #fff;\n\tlist-style: none;\n\toverflow: hidden;\n\tpadding: 0;\n\tjustify-content: space-between;\n\toverflow: hidden;\n\tborder: 2px solid ", ";\n\tflex-direction: row;\n\n\t@media (max-width: ", ") {\n\t\tfont-size: 12px;\n\t}\n\n\t@media (min-width: ", ") {\n\t\tdisplay: flex;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var ARROW_SIZE = '1.5rem';

var Steps = _styledComponents.default.ul(_templateObject(), _colors.default.primary, _breakpoints.default.tablet, function (props) {
  return props.visibleFrom;
});

Steps.displayName = 'Steps';

var Step = _styledComponents.default.li(_templateObject2(), function (props) {
  return props.onClick && 'cursor: pointer';
}, ARROW_SIZE, _spacing.default.s1, _spacing.default.s1, _spacing.default.s5, ARROW_SIZE, _colors.default.primary, function (props) {
  return props.isComplete && "\n\t\tcolor: inherit;\n\t\tbackground-color: " + _colors.default.primaryLight + ";\n\n\t\t&:after {\n\t\t\tborder-left-color: " + _colors.default.primaryLight + ";\n\t\t}";
}, function (props) {
  return props.isCurrent && "color: #fff;\n\t\tbackground-color: " + _colors.default.primary + ";\n\n\t\t&:after {\n\t\t\tborder-left-color: " + _colors.default.primary + ";\n\t\t}";
});

Step.displayName = 'Step';

var ProgressSteps = function ProgressSteps(_ref) {
  var steps = _ref.steps,
      currentIndex = _ref.currentIndex,
      onStepClick = _ref.onStepClick,
      props = _objectWithoutPropertiesLoose(_ref, ["steps", "currentIndex", "onStepClick"]);

  return _react.default.createElement(Steps, props, steps.map(function (_ref2, i) {
    var id = _ref2.id;
    var isCurrent = i === currentIndex;
    return _react.default.createElement(Step, {
      "data-testid": id,
      key: id,
      isComplete: i <= currentIndex,
      isCurrent: isCurrent,
      "aria-current": isCurrent ? 'step' : undefined,
      onClick: onStepClick ? function () {
        return onStepClick(i);
      } : undefined
    }, _react.default.createElement("span", null, id));
  }));
};

ProgressSteps.displayName = 'ProgressSteps';
ProgressSteps.propTypes = {
  visibleFrom: _propTypes.string,
  steps: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
  })).isRequired,
  currentIndex: _propTypes.number.isRequired,
  onStepClick: _propTypes.func
};
ProgressSteps.defaultProps = {
  visibleFrom: '72rem',
  onStepClick: undefined
};
var _default = ProgressSteps;
exports.default = _default;